import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  spinURL: "",
  uploadFilename: "",
};

export const spinURLSlice = createSlice({
  name: "spinURL",
  initialState,
  reducers: {
    setSpinURL(state, action) {
      state.spinURL = action.payload;
    },
    setUploadFilename(state, action) {
      state.uploadFilename = action.payload;
    },
  },
});

export const { setSpinURL, setUploadFilename } = spinURLSlice.actions;

export default spinURLSlice.reducer;

//========== SELECTORS ============
export const getSpinURL = (state) => state.spinURL;
export const getUploadFilename = (state) => state.uploadFilename;
